import { BundleMiniItem, BundleLaundryMiniItem } from './bundle-item/index';

const Templates = {
  BundleMiniItem,
  BundleLaundryMiniItem
};

export const getTemplate = (templateName) => Templates?.[templateName] || null;